const SHARE_HASH_PREFIX = '#session=';

const encodePayload = (payload) => {
  const json = JSON.stringify(payload);
  const utf8 = encodeURIComponent(json);
  return btoa(utf8);
};

const decodePayload = (encoded) => {
  const json = decodeURIComponent(atob(encoded));
  return JSON.parse(json);
};

export const buildSessionShareHash = ({username, password}) => {
  if (!username || !password) return null;
  const encoded = encodePayload({username, password});
  return `${SHARE_HASH_PREFIX}${encodeURIComponent(encoded)}`;
};

export const buildSessionShareLink = ({username, password, path = '/app/dashboard'}) => {
  const hash = buildSessionShareHash({username, password});
  if (!hash) return null;
  return `${window.location.origin}${path}${hash}`;
};

export const parseSessionShareHash = (hash) => {
  if (!hash || !hash.startsWith(SHARE_HASH_PREFIX)) return null;
  const encoded = hash.slice(SHARE_HASH_PREFIX.length);
  if (!encoded) return null;
  try {
    const decoded = decodePayload(decodeURIComponent(encoded));
    if (!decoded?.username || !decoded?.password) return null;
    return decoded;
  } catch (error) {
    console.error('Failed to decode session share hash:', error);
    return null;
  }
};

export const isSessionShareHash = (hash) => Boolean(parseSessionShareHash(hash));

